import React from 'react'
import UseStateComponent from './_UseStateComponent'
import UseEffectComponent from './_UseEffectComponent'
import UseContextComponent from './_UseContextComponent'
import UseReducerComponent from './_UseReducerComponent'
import UseRefComponent from './_UseRefComponent'
// import CustomHookComponent from './_CustomHookComponent'
import DataFetchingComponent from './_DataFetchingComponent'

import EvenMoreReactComponent from './_EvenMoreReactComponent'

const WipApp = function () {
  return (
    <div className="col-12 p-4">
      <br />
      <br />
      <h5>useState</h5>
      <UseStateComponent />
      <br />
      <br />
      <h5>useEffect</h5>
      <UseEffectComponent />
      <br />
      <br />
      <h5>useContext</h5>
      <UseContextComponent />
      <br />
      <br />
      <h5>useRef</h5>
      <UseRefComponent />
      <br />
      <br />
      <h5>useReducer</h5>
      <UseReducerComponent />
      <br />
      <br />
      <h5>Even more React component TS stuff</h5>
      <EvenMoreReactComponent />
      <br />
      <br />
      {/* <h5>Custom Hook with useMemo</h5> */}
      <h5>Custom Hook with data fetch</h5>
      <DataFetchingComponent url="https://jsonplaceholder.typicode.com/posts" />
      <br />
      <br />
    </div>
  )
}

export default WipApp
